import { Gmoshop } from '@linktivity/link-connect';
import config from '../config';

const accountApi = new Gmoshop.AccountApi(config);

export default accountApi;
